import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Image } from "antd";
import YoutubeIcon from '../../../../assets/YoutubeIcon';


const CreateLiveAccount = () => {
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.user);
    const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim()
    const [isOpenModal, setIsOpenModal] = useState(false);
    return (
        <div className='flex justify-center items-center flex-col h-[calc(100vh-150px)]'>
            {/* <div className='opacity-35 mb-3'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={175} fill={primaryColor}><path d="M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z" /><path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z" /></svg>
            </div> */}
            <img src="/assets/images/welcome.svg" alt="" style={{ height: 350, width: '100%' }} />
            <div>
            </div>
            <div className=''>
                <p className="font-bold text-[#2F2B3D] sm:text-4xl text-xl text-center">👋 Welcome <span className=' primary font-semibold capitalize'>
                    {userDetails?.firstName} {userDetails?.lastName}</span></p>
            </div>
            <p className="mt-4 text-center">Your trading dashboard is ready. Manage risks wisely, and let opportunities come to you</p>
            {/* <div className='font-bold text-[#2F2B3D] sm:text-3xl text-xl text-center mt-4'>
                You have no live Account
            </div> */}
            <p className="mt-4 text-center">
                {userDetails?.kycStatus
                    ? "To get started, you'll need to create an account"
                    : "To get started, please complete your KYC process"}
            </p>

            <button className='bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover duration-500 mt-5' onClick={() => navigate('/account?type=live')}>   {userDetails?.kycStatus ? 'Open Live Account' : 'Complete KYC'} </button>

            <button className=' bg-[var(--theme2)] text-white font-semibold px-9 py-2 rounded-lg mt-7 flex justify-center items-center gap-2' onClick={() => setIsOpenModal(true)} >
                <span><YoutubeIcon /></span> <span>View Tutorial For Getting Started</span>
            </button>

            {isOpenModal && (
                <Image
                    style={{ display: "none" }}
                    preview={{
                        visible: isOpenModal,
                        onVisibleChange: (value) => setIsOpenModal(value),
                        destroyOnHidden: true,
                        maskClassName: "!bg-black !bg-opacity-90",
                        imageRender: () => (
                            <div className="fixed inset-0  bg-opacity-60 flex items-center justify-center p-4">
                                <div className="w-full h-full max-w-6xl flex items-center justify-center">
                                    <div className='relative w-full h-full'>
                                        <iframe
                                            src="https://www.youtube.com/embed/videoseries?list=PLQf-ZwtTMD1UMJVceEsEUIv7MrvH6qNCC&autoplay=1"
                                            title="Process Video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ),
                        toolbarRender: () => null,
                    }}
                />
            )}


        </div>
    )
}

export default CreateLiveAccount